export interface CustomFieldClass{
    AccountCustomFieldId: string
    AccountId: number
    MasterCustomDataTypeId: string
    MasterEntityTypeId: string
    DatabaseFieldName:string
    CustomFieldName:string
    CustomFieldCaption:string
    DefaultValue:string
    MaximumLength:number
    MinimumValue:number
    MaximumValue:number
    DropDownOptions:string
    IsRequired:boolean
    IsDisabled:boolean
    MasterEntityTypeName: string
    isSelected:number
}

export interface MasterEntityTypeClass{
    MasterEntityTypeId: string
    MasterEntityTypeName: string
    SystemFeatureId: string
    MasterEntityValidationGroup:string
}

const common = {    
    AccountCustomFieldId:"00000000-0000-0000-0000-000000000000",
    AccountId: 0,
    MasterCustomDataTypeId: "",
    MasterEntityTypeId: "",
    DatabaseFieldName:"",
    CustomFieldName:"",
    CustomFieldCaption:"",
    DefaultValue:"",
    MaximumLength:0,
    MinimumValue:0,
    MaximumValue:0,
    DropDownOptions:"",
    IsRequired:false,
    IsDisabled:false
  };


export const CustomFieldInitialsForAdd ={ ...common };

export const CustomFieldInitialsForUpdate = {
    ...common
   
}
